// extracted by mini-css-extract-plugin
export default {"input":"SearchTextInput_input__lS141"};